import { jsxs, jsx } from "react/jsx-runtime";
import "react";
import { Box, Heading } from "@zillow/constellation";
import { useLastValidRefinanceValues } from "./RefinanceCalculator.utils.esm.js";
import { getWholeDollars } from "../../utils/zhl-calculator.esm.js";
const SavingsHeader = () => {
  const values = useLastValidRefinanceValues();
  const headerText = values.calculations.monthlySavings > 0 || values.calculations.lifetimeSavings > 0 ? "Refinancing could save you" : "Sorry, refinancing will not save you money";
  let savingsText = null;
  const {
    monthlySavings,
    lifetimeSavings
  } = values.calculations || {};
  if (monthlySavings > 0) {
    savingsText = `${getWholeDollars(monthlySavings)} /mo`;
  } else if (lifetimeSavings > 0) {
    savingsText = getWholeDollars(lifetimeSavings);
  }
  return /* @__PURE__ */ jsxs(Box, { sx: {
    textAlign: "center"
  }, children: [
    /* @__PURE__ */ jsx(Heading, { level: "5", children: headerText }),
    /* @__PURE__ */ jsx(Heading, { level: "3", children: savingsText })
  ] });
};
export {
  SavingsHeader as default
};
